<template>
  <div @mouseover="userTypeSetup">
    <div class="title-bar detail clearfix">
      <div class="module pull-left">
        {{ $t("editCodeScanning") }}
      </div>
      <div style="float:right;">
        <el-button plain size="mini" @click="addCodeScanning('addCodeScanningForm')">{{ $t("save") }}
        </el-button>
        <el-button plain size="mini" @click="cancelOperation">{{ $t("cancel") }}
        </el-button>
      </div>
    </div>

    <div class="data-list detail">
      <div class="detail-header">
        <span> {{ $t("CodeScanningInformation") }}</span>
        <div class="detail-triangle"></div>
      </div>

      <div class="detail-content">
        <el-form class="detail-form" size="small" ref="addCodeScanningForm" :model="CodeScanningInfo" label-width="120px" :rules="rules" status-icon>
          <el-row>

            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('ScanningTimes')" prop="ScanningTimes">
                <el-tooltip effect="dark" content="0 表示未找到产品号" placement="right">
                  <el-input v-model="CodeScanningInfo.ScanningTimes"></el-input>
                </el-tooltip>
              </el-form-item>
            </el-col>
            <el-col :xs="24" :sm="12" :md="12" :lg="12">
              <el-form-item :label="this.$t('ScanningMessage')" prop="ScanningMessage">
                <el-input type="textarea" v-model="CodeScanningInfo.ScanningMessage"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>

  </div>
</template>
 <script>
import _ from "lodash";
export default {
  name: "EditCodeScanningInformation",
  data() {
    return {
      userTypeList: [],
      QRCTypeList: [],

      CodeScanningInfo: {
        CodeType: "",
        UserType: "",
        ScannningTimes: "",
        ScanningMessage: ""
      },

      rules: {
        CodeType: [{ required: true, message: this.$t("CodeTypeValidation") }],
        UserType: [
          { required: true, message: this.$t("UserTypeCodeValidation") }
        ],
        ScanningTimes: [
          { required: true, message: this.$t("ScanningTimesValidation") },

          {
            validator: (rule, value, callback) => {
              var raw = JSON.stringify(value).replace(/\"/g, "");
              var format = raw.replace(/[^0-9]/g, "");
              if (raw.length > format.length) {
                callback(new Error("请输入一个整数"));
              } else {
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        ScanningMessage: [
          { required: true, message: this.$t("ScanningMessageValidation") }
        ]
      }
    };
  },
  created() {
    this.$axios
      .get(`api/codescanning/${this.$route.params.Id}`)
      .then(response => {
        this.CodeScanningInfo = response.data;
      });
  },
  methods: {
    userTypeSetup() {
      if (this.userTypeList == "") {
        for (var i = 2; i <= 4; i++) {
          this.userTypeList.push(i);
        }
        this.userTypeList.push(8);
      }
      if (this.QRCTypeList == "") {
        this.QRCTypeList.push(1);
        this.QRCTypeList.push(2);
      }
    },
    handlekeyup(event) {
      var father = event.currentTarget;
      var input = father.getElementsByTagName("input")[0];
      input.value = input.value.replace(/[^0-9]/g, "");
    },
    addCodeScanning(addCodeScanningForm) {
      this.$refs[addCodeScanningForm].validate(valid => {
        if (valid) {
          this.$axios
            .post("api/codescanning/addoredit", this.CodeScanningInfo)
            .then(response => {
              this.$message({
                message: this.$t("editCodeScanningSuccessfully"),
                type: "success",
                showClose: true,
                duration: 2000
              });
              this.$router.push("CodeScanningInformation");
            })
            .catch(err => {
              this.$message({
                message: this.$t(err.response.statusText),
                type: "error",
                showClose: true,
                duration: 2000
              });
            });
        } else {
          this.$message({
            message: this.$t("operationFailure"),
            type: "error",
            showClose: true,
            duration: 2000
          });
        }
      });
    },
    cancelOperation() {
      this.$router.push("CodeScanningInformation");
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/application/CodeScanningInformation/EditCodeScanningInformation.vue